const storageKey = 'gp_url_garantidora'
const logoStorageKey = 'gp_logo_garantidora'
const logoutStorageKey = 'gp_logout_url_garantidora'
const keyPattern = /^[A-Za-z0-9_-]{1,100}$/

export function normalizeGuarantorUrl (value) {
  if (value === null || value === undefined) return null

  let candidate = String(value).trim()
  if (!candidate) return null

  try {
    candidate = new URL(candidate).pathname
  } catch {
    candidate = candidate.split(/[?#]/, 1)[0]
  }

  const segments = candidate.split('/').map(item => item.trim()).filter(Boolean)
  if (!segments.length) return null

  try {
    candidate = decodeURIComponent(segments[segments.length - 1])
  } catch {
    return null
  }

  return keyPattern.test(candidate) ? candidate : null
}

export function getActiveGuarantorUrl () {
  return normalizeGuarantorUrl(window.sessionStorage.getItem(storageKey))
}

export function setActiveGuarantorUrl (value) {
  const normalized = normalizeGuarantorUrl(value)
  if (!normalized) {
    clearActiveGuarantorUrl()
    return null
  }

  const current = getActiveGuarantorUrl()
  if (current && current !== normalized) clearActiveGuarantorLogoUrl()

  window.sessionStorage.setItem(storageKey, normalized)
  return normalized
}

export function clearActiveGuarantorUrl () {
  window.sessionStorage.removeItem(storageKey)
  clearActiveGuarantorLogoUrl()
}

export function normalizeGuarantorLogoUrl (value) {
  if (value === null || value === undefined) return null

  try {
    const url = new URL(String(value).trim())
    return ['http:', 'https:'].includes(url.protocol) ? url.toString() : null
  } catch {
    return null
  }
}

export function getActiveGuarantorLogoUrl () {
  return normalizeGuarantorLogoUrl(window.sessionStorage.getItem(logoStorageKey))
}

export function setActiveGuarantorLogoUrl (value) {
  const normalized = normalizeGuarantorLogoUrl(value)
  if (!normalized) {
    clearActiveGuarantorLogoUrl()
    return null
  }

  window.sessionStorage.setItem(logoStorageKey, normalized)
  return normalized
}

export function clearActiveGuarantorLogoUrl () {
  window.sessionStorage.removeItem(logoStorageKey)
}

export function prepareGuarantorLogout () {
  const guarantorUrl = getActiveGuarantorUrl()
  if (!guarantorUrl) {
    window.sessionStorage.removeItem(logoutStorageKey)
    return null
  }

  window.sessionStorage.setItem(logoutStorageKey, guarantorUrl)
  return guarantorUrl
}

export function consumeGuarantorLogoutUrl () {
  const guarantorUrl = normalizeGuarantorUrl(window.sessionStorage.getItem(logoutStorageKey))
  window.sessionStorage.removeItem(logoutStorageKey)
  return guarantorUrl
}
